import React from 'react';

interface IntentionInputProps {
  value: string;
  onChange: (value: string) => void;
  onRemove: () => void;
  canRemove: boolean;
  error?: string;
  placeholder?: string;
}

/**
 * Intention Input Component
 * Text input for entering user intentions with validation
 */
export const IntentionInput: React.FC<IntentionInputProps> = ({
  value,
  onChange,
  onRemove,
  canRemove,
  error,
  placeholder = 'Enter your intention...',
}) => {
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={500}
          className={`flex-1 focus:outline-none ${
            error ? 'border-red-500' : ''
          }`}
          style={{
            height: '48px',
            paddingLeft: '16px',
            paddingRight: '16px',
            borderRadius: '15px',
            outline: error ? '1px solid #ef4444' : '1px solid rgba(255, 255, 255, 0.4)',
            outlineOffset: '-1px',
            backgroundColor: 'transparent',
            border: 'none',
            fontFamily: 'Space Grotesk',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '24px',
            color: value ? '#FFFFFF' : 'rgba(255, 255, 255, 0.6)',
          }}
          aria-label={placeholder}
          aria-invalid={!!error}
          aria-describedby={error ? `error-${placeholder}` : undefined}
        />
        {canRemove && (
          <button
            onClick={onRemove}
            className="min-h-[48px] min-w-[44px] px-3 text-white-p60 transition-opacity active:opacity-80"
            style={{
              fontFamily: 'Space Grotesk',
              fontSize: '24px',
              lineHeight: '24px',
            }}
            aria-label="Remove intention"
          >
            ×
          </button>
        )}
      </div>
      {error && (
        <p 
          id={`error-${placeholder}`} 
          className="text-sm text-red-500" 
          role="alert"
          style={{
            fontFamily: 'Space Grotesk',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16.8px',
            letterSpacing: '0.24px',
          }}
        >
          {error}
        </p>
      )}
      {value && (
        <p 
          className="text-xs text-white-p60"
          style={{
            fontFamily: 'Space Grotesk',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16.8px',
            letterSpacing: '0.24px',
          }}
        >
          {value.length} / 500 characters
        </p>
      )}
    </div>
  );
};

export default IntentionInput;
